import { Component, OnDestroy, OnInit } from "@angular/core";
import { RoleDetailDto, RoleDto } from "./models/role-models";
import { ModalService } from "../../services/modal.service";
import { Subject, Subscription } from "rxjs";
import { RoleDataService } from "./services/role-data.service";
import { NotificationService } from "../../services/notification.service";
import { CheckboxUpdateService } from "../../services/checkbox-update.service";
import { RoleDetailUpdateService } from "./services/role-detail-update.service";
import { PermissionService } from "../../services/permission.service";

@Component({
	selector: "app-role-list",
	templateUrl: "./role-list.component.html",
	styleUrls: ["./role-list.component.scss"],
})
export class RoleListComponent implements OnInit, OnDestroy {
	roleList: RoleDto[] = [];
	roleDetail: Subject<RoleDetailDto> = new Subject<RoleDetailDto>();

	isOpenModalDeleteRole = false;
	isOpenModalAddRole = false;
	isOpenModalEditRole = false;
	isOpenModalAddedRole = false;
	isOpenModalEditingRole = false;

	aSub: Subscription | undefined;

	currentRole: RoleDto | undefined;

	constructor(
		private modalService: ModalService,
		private rolaDataService: RoleDataService,
		private notificationService: NotificationService,
		private checkboxUpdateService: CheckboxUpdateService,
		private roleDetailUpdateService: RoleDetailUpdateService,
		private permissionService: PermissionService
	) {}

	ngOnInit() {
		this.initModal();
		this.loadRoleList();
	}

	ngOnDestroy() {
		this.aSub?.unsubscribe();
	}

	loadRoleList() {
		this.roleList = [];
		this.rolaDataService.loadRoleList().subscribe({
			next: (res) => {
				this.roleList = res;
			},
		});
	}

	initModal() {
		this.aSub = this.modalService.isModalOpen$.subscribe({
			next: (res) => {
				if (!res) {
					this.isOpenModalDeleteRole = false;
					this.isOpenModalAddRole = false;
					this.isOpenModalEditRole = false;
					this.isOpenModalEditingRole = false;
				}
			},
		});
	}

	openDeleteModal(item: RoleDto) {
		this.currentRole = item;
		this.isOpenModalDeleteRole = true;
	}

	deleteRole(id: any) {
		this.rolaDataService.deleteRole(id).subscribe({
			complete: () => {
				this.modalService.isModalOpen$.next(false);

				this.notificationService.setConfiguration(
					"icon-6",
					"error",
					"ROLE_PAGE.NOTIFICATION.DELETE_HEADLINE",
					"ROLE_PAGE.NOTIFICATION.EDITING_DESCRIPTION"
				);

				this.notificationService.showNotification();

				this.loadRoleList();
			},
		});
	}

	addRole() {
		this.roleDetailUpdateService.roleDetailUpdate.next(null);
		this.checkboxUpdateService.checkboxUpdate$.next();
		this.isOpenModalAddRole = true;
	}

	editRole(id: number) {
		if (this.permissionService.hasPermission(["ROLES_EDIT"])) {
			this.rolaDataService.loadRoleDetail(id.toString()).subscribe({
				next: (res) => {
					this.roleDetailUpdateService.roleDetailUpdate.next(res);
					this.isOpenModalEditRole = true;
					this.checkboxUpdateService.checkboxUpdate$.next();
				},
			});
		} else {
			this.notificationService.setConfiguration(
				"icon-1",
				"warning",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_ERROR",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_DESCRIPTION"
			);

			this.notificationService.showNotification();
		}
	}

	addedRole() {
		this.loadRoleList();
		this.isOpenModalAddRole = false;

		this.modalService.isModalOpen$.next(false);
		this.notificationService.setConfiguration(
			"icon-4",
			"success",
			"ROLE_PAGE.NOTIFICATION.ADDED_HEADLINE",
			"ROLE_PAGE.NOTIFICATION.EDITING_DESCRIPTION"
		);
		this.notificationService.showNotification();
		this.isOpenModalAddedRole = true;
	}

	editingRole() {
		this.loadRoleList();
		this.modalService.isModalOpen$.next(false);
		this.notificationService.setConfiguration(
			"icon-2",
			"warning",
			"ROLE_PAGE.NOTIFICATION.EDITING_HEADLINE",
			"ROLE_PAGE.NOTIFICATION.EDITING_DESCRIPTION"
		);
		this.notificationService.showNotification();
	}
}
